import { CategoryApplicantAnswersReviewStep } from './CategoryApplicantAnswersReviewStep';
import useCategoryFeedbackFormHandling from './useCategoryFeedbackFormHandling';
import { DietaryHabitsAndHealthUIConfig } from '../../../shared/CategoryStepUIConfig';
import { useApplicantAnswersReview } from './useApplicantAnswersReview';
import useUserSession from '../../../hooks/useUserSession';
import { ALLOWED_ROLES } from '../../../shared/Utils';
import { UserRole } from '../../../shared/VolunteerApplicationServiceTypes';

const UiConfig = DietaryHabitsAndHealthUIConfig;

export const DietaryHabitsAndHealthAnswersReviewStep = () => {
	const { dietaryHabitsAndHealth, setDietaryHabitsAndHealth, application } =
		useApplicantAnswersReview();
	const { selectedRole } = useUserSession();

	const isRoleNotAllowed = !ALLOWED_ROLES.includes(selectedRole as UserRole);

	const { form } = useCategoryFeedbackFormHandling(
		dietaryHabitsAndHealth,
		setDietaryHabitsAndHealth
	);

	return (
		<CategoryApplicantAnswersReviewStep
			uiConfig={UiConfig}
			form={form}
			answers={application?.userAnswers}
			showCheckbox
			disable={isRoleNotAllowed}
		/>
	);
};
